import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { bootstrapCalendarFill } from '@ng-icons/bootstrap-icons';
import { MasterContactService } from '../../../../../../../shared/master-contact/master-contact.service';
import { AsyncPipe } from '@angular/common';
import { RemoveNgbDateDatepickerDefaultValidation } from '../../../../../../../shared/directives/NgbDateTime/disable-default-validation.directive';
import { AddressPickerComponent } from '../../../../../../../shared/components/address-picker/address-picker.component';
import { CustomDateFormatter } from '../../../../../../../shared/ngb-datepicker/NgbDateCustomParserFormatter';

@Component({
  selector: 'app-collect-from-form',
  standalone: true,
  imports: [ReactiveFormsModule,
    NgSelectModule,
    NgIconComponent,
    NgbDatepickerModule,
    NgbTimepickerModule,
    AsyncPipe,
    RemoveNgbDateDatepickerDefaultValidation,
    AddressPickerComponent
  ],
  templateUrl: './collect-from-form.component.html',
  styleUrl: './collect-from-form.component.scss',
  providers: [
    {
      provide: NgbDateParserFormatter,
      useClass: CustomDateFormatter
    }
  ],
  viewProviders: [provideIcons(
    {
      bootstrapCalendarFill
    }
  ),
  ]
})
export class CollectFromFormComponent implements OnInit {

  @Input()
  formGroup!: FormGroup;
  @Input()
  disableEmitter!: EventEmitter<boolean>;

  lockdown: boolean = false;

  constructor(private formBuilder: FormBuilder, private masterContactService: MasterContactService) { }

  ngOnInit() {
    this.disableEmitter.subscribe((value) => {
      if (value) {
        this.formGroup.disable({ emitEvent: false });
      } else {
        this.formGroup.enable();
      }
      this.lockdown = value;
    });
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup.addControl('collectFrom', this.formBuilder.group({
      addressSelection: this.formBuilder.group({}, [Validators.required]),
      preciseLocationOptions: this.formBuilder.group({}),
      pickupOpen: this.formBuilder.group({
        date: this.formBuilder.control({}),
        time: this.formBuilder.control({
          hour: 12,
          minute: 0
        })
      }),
      pickupClose: this.formBuilder.group({
        date: this.formBuilder.control({}),
        time: this.formBuilder.control({
          hour: 12,
          minute: 0
        })
      }),
      siteContactId: this.formBuilder.control(0),
      siteContact: this.formBuilder.control(null),
      siteContactPhone: this.formBuilder.control(''),
      siteContactEmail: this.formBuilder.control('', [Validators.email]),
    }));

    this.formGroup.get('collectFrom')?.valueChanges.subscribe((value) => {
      if (!value.pickupOpen) {
        return;
      }
      if (!value.pickupOpen.time) {
        value.pickupOpen.time = { hour: 12, minute: 0 };
      }
      if (!value.pickupClose.time) {
        value.pickupClose.time = { hour: 12, minute: 0 };
      }
      this.formGroup.get('collectFrom')?.patchValue(value, { emitEvent: false });
    });
  }

  siteContactNameAltered() {
    const siteContactName = this.formGroup.get('collectFrom.siteContact')?.value;
    this.formGroup.get('collectFrom.siteContact')?.patchValue(siteContactName?.trim(), { emitEvent: false });
  }

  siteContactPhoneAltered() {
    const siteContactPhone = this.formGroup.get('collectFrom.siteContactPhone')?.value;
    this.formGroup.get('collectFrom.siteContactPhone')?.patchValue(siteContactPhone?.trim(), { emitEvent: false });
  }

  getFormGroup() {
    if (!this.formGroup.get('collectFrom')) {
      this.initializeForm();
    }
    return this.formGroup.get('collectFrom') as FormGroup;
  }
}
